<template>
  <v-toolbar
    v-if="!toolbarDisabled"
    dense
    flat
    :style="{ background: titleStyle }"
  >
    <v-btn v-if="!backDisabled" :disabled="backDisabled" icon @click="GoBack()">
      <v-icon v-html="backIcon"></v-icon>
    </v-btn>

    <v-spacer></v-spacer>

    <template v-if="title.visible">
      <img
        v-if="title.icon != ''"
        style="height: 24px; width: 24px; vertical-align: middle"
        :src="title.icon"
      />
      <v-toolbar-title v-if="title.visible" class="black--text toolbar-title">
        {{ title.title }}
      </v-toolbar-title>
    </template>
    <template v-else-if="titleList.visible">
      <img
        v-if="titleList.curIcon != ''"
        style="height: 24px; width: 24px; vertical-align: middle; margin-right: 4px;"
        :src="titleList.curIcon"
      />
      <v-select
        class="toolbar-titlelist"
        :items="titleList.list"
        v-model="titleList.curValue"
        solo
        flat
        append-icon="$vuetify.icons.dropdown"
        @change="(e) => onSelectChage(e)"
        noDataText="没有数据"
      ></v-select>
    </template>
    <v-spacer></v-spacer>

    <!--v-if="menuDisabled && !backDisabled" 注：功能按钮跟回退按钮、菜单按钮配合，使得title居中显示 -->
    <v-btn
      v-if="menuDisabled && !backDisabled"
      :disabled="singleButtonDisabled"
      @click="singleButton.func"
      icon
    >
      <v-icon :color="singleButton.color" v-html="singleButton.title"></v-icon>
    </v-btn>
    <v-menu v-if="!menuDisabled" class="menu-list" bottom left>
      <v-btn slot="activator" :disabled="menuDisabled" icon>
        <v-icon v-html="menuIcon"></v-icon>
      </v-btn>

      <v-list v-if="!menuDisabled">
        <v-list-tile
          v-for="(item, i) in items"
          :key="i"
          @click="menuClick(item)"
        >
          <v-list-tile-title :class="[{ 'menu-select': item.func == null }]">
            {{ item.title }}
          </v-list-tile-title>
          <v-icon color="blue darken-2" v-if="!item.func">search</v-icon>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import msgbus from '../msgBus'
import debugHelper from '../util/debug'

export default {
  name: 'iDS-ToolBar',
  data() {
    return {
      curTitle: '123',
    }
  },
  computed: {
    titleStyle() {
      if (!this.getTitleStyle()) return '#FFF'
      else return this.getTitleStyle()
    },
    toolbarDisabled() {
      return this.getToolbarDisabled()
    },

    backDisabled() {
      return this.getBackDisabled()
    },

    title() {
      return msgbus.vm.getTitleInfo()
    },
    titleList() {
      console.log('调试代码')
      var tmp = msgbus.vm.getTitleList()
      return tmp
    },
    backIcon() {
      return this.getBackIcon()
    },

    singleButtonDisabled() {
      return msgbus.vm.getSingleButtonDisabled()
    },

    singleButton() {
      return msgbus.vm.getSingleButton()
    },

    menuDisabled() {
      return msgbus.vm.getMenuDisabled()
    },

    menuIcon() {
      return msgbus.vm.getMenuIcon()
    },

    items() {
      return msgbus.vm.getMenuItems()
    },
  },
  methods: {
    menuClick(item) {
      item.func ? item.func() : this.emptyClick()
    },
    emptyClick() {},
    GoBack() {
      console.log('代码调试')
      // setBackDisabled会清空特殊路由信息，因此调用之前先读取是否特殊路由信息
      var backSpecialRoute = this.getBackSpecialRoute()
      this.setBackDisabled(true)

      // 若有特殊路由设置信息，则调转到指定页面
      if (backSpecialRoute && backSpecialRoute != '') {
        this.$router.replace({ name: backSpecialRoute })
      } else {
        this.$router.back()
      }
    },
    setTitleIcon() {
      console.log('调试代码')
      this.titleList.curIcon = ''
      if (this.titleList.listIcon) {
        this.titleList.listIcon.forEach((element) => {
          if (element.name == this.titleList.curValue) {
            this.titleList.curIcon = element.icon
          }
        })
      }
    },
    onSelectChage(e) {
      this.setTitleIcon()
      this.titleList.change(e)
    },
    ...mapGetters('app', [
      'getBackDisabled',
      'getBackSpecialRoute',
      'getBackIcon',
      'getToolbarDisabled',
      'getTitleStyle',
    ]),
    ...mapActions('app', ['setBackDisabled']),
  },
}
</script>

<style lang="scss">
.toolbar-title {
  font-size: 1.4rem !important;
  margin-left: 0 !important;
}

.toolbar-titlelist {
  flex: 100 1 auto;
  font-size: 1.2rem !important;
  margin-left: 0 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .v-input__slot {
    padding: 0 !important;
    margin: 0;
  }
  .v-select__selections {
    overflow: hidden;

    .v-select__selection--comma {
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
      letter-spacing: 0.02em;
      margin: 0 !important;
      display: block;
      max-width: 100%;
      padding: 4px 0;
    }
    input {
      display: none;
    }
  }
}

.v-menu__content {
  z-index: 1000 !important;
}
.menu-select {
  color: #1976d2;
}
</style>
